var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-avatar',{staticClass:"card-head",attrs:{"type":_vm.type,"id":_vm.id,"size":_vm.size,"data-band":_vm.band}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }